(function () {
  'use strict';
  if (window.rxCommerceTracking) return;

  var VERSION = '1.0.0';
  var nativeFetch = window.fetch;
  var lastCart = null;
  var checkoutIntentAt = 0;

  window.dataLayer = window.dataLayer || [];

  function number(value) {
    value = Number(value);
    return isFinite(value) ? value : 0;
  }

  function item(raw, quantityOverride) {
    return {
      product_id: raw.product_id || null,
      variant_id: raw.variant_id || raw.id || null,
      sku: raw.sku || null,
      name: raw.product_title || raw.title || null,
      variant: raw.variant_title || null,
      price: number(raw.final_price !== undefined ? raw.final_price : raw.price) / 100,
      quantity: quantityOverride !== undefined ? quantityOverride : number(raw.quantity)
    };
  }

  function cartPayload(cart) {
    cart = cart || {};
    return {
      currency: cart.currency || 'RON',
      value: number(cart.total_price) / 100,
      item_count: number(cart.item_count),
      items: Array.isArray(cart.items) ? cart.items.map(function (entry) { return item(entry); }) : []
    };
  }

  function push(name, cart, changedItems, stage) {
    var payload = cartPayload(cart);
    if (changedItems) payload.changed_items = changedItems;
    window.dataLayer.push({
      event: name,
      rx_event_version: 1,
      rx_event_stage: stage || 'confirmed',
      rx_ecommerce: payload
    });
  }

  function cartMap(cart) {
    var map = {};
    ((cart && cart.items) || []).forEach(function (entry) {
      map[String(entry.key || entry.variant_id || entry.id)] = entry;
    });
    return map;
  }

  function changes(before, after) {
    var previous = cartMap(before);
    var current = cartMap(after);
    var removed = [];
    var updated = [];
    Object.keys(previous).forEach(function (key) {
      var oldItem = previous[key];
      var newItem = current[key];
      var oldQuantity = number(oldItem.quantity);
      var newQuantity = newItem ? number(newItem.quantity) : 0;
      if (newQuantity < oldQuantity) removed.push(item(oldItem, oldQuantity - newQuantity));
      if (newItem && newQuantity !== oldQuantity) updated.push(item(newItem, newQuantity));
    });
    Object.keys(current).forEach(function (key) {
      if (!previous[key]) updated.push(item(current[key]));
    });
    return { removed: removed, updated: updated };
  }

  function sameOriginCartPath(url) {
    try {
      var parsed = new URL(url, location.href);
      if (parsed.origin !== location.origin) return null;
      var match = parsed.pathname.match(/\/cart\/(add|change|update|clear)\.js\/?$/);
      return match ? match[1] : null;
    } catch (error) { return null; }
  }

  function readCart() {
    return nativeFetch.call(window, '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart snapshot failed');
      return response.json();
    });
  }

  function observeMutation(kind, response) {
    if (!response.ok) return;
    var before = lastCart;
    var bodyPromise = response.clone().json().catch(function () { return null; });
    Promise.all([bodyPromise, readCart().catch(function () { return null; })]).then(function (result) {
      var body = result[0];
      var cart = result[1] || (body && Array.isArray(body.items) ? body : null);
      if (!cart) return;

      if (kind === 'add') {
        var added = body && body.items ? body.items : (body ? [body] : []);
        push('rx_cart_add', cart, added.map(function (entry) { return item(entry); }));
      } else {
        var delta = changes(before, cart);
        if (delta.removed.length) push('rx_cart_remove', cart, delta.removed);
        if (delta.updated.length) push('rx_cart_update', cart, delta.updated);
      }
      lastCart = cart;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input);
    var kind = sameOriginCartPath(url);
    return nativeFetch.apply(this, arguments).then(function (response) {
      if (kind) observeMutation(kind, response);
      return response;
    });
  };

  function checkoutIntent() {
    var now = Date.now();
    if (now - checkoutIntentAt < 2000) return;
    checkoutIntentAt = now;
    push('rx_checkout_intent', lastCart || {}, null, 'intent');
  }

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout') checkoutIntent();
  }, true);

  document.addEventListener('click', function (event) {
    var node = event.target && event.target.closest ? event.target.closest('a,button,input') : null;
    if (!node) return;
    var href = node.getAttribute && node.getAttribute('href');
    if (href) {
      try {
        var parsed = new URL(href, location.href);
        if (parsed.origin === location.origin && /\/cart\/change\/?$/.test(parsed.pathname) && parsed.searchParams.get('quantity') === '0') {
          var line = number(parsed.searchParams.get('line'));
          var removedItem = lastCart && lastCart.items && lastCart.items[line - 1];
          push('rx_cart_remove', lastCart || {}, removedItem ? [item(removedItem)] : [], 'intent');
        }
      } catch (error) {}
    }
    if ((node.name === 'checkout') || (href && /(?:^|\/)checkout(?:[/?#]|$)/i.test(href))) checkoutIntent();
  }, true);

  function start() {
    readCart().then(function (cart) {
      lastCart = cart;
      if (/\/cart\/?$/.test(location.pathname)) push('rx_cart_view', cart, null, 'observed');
    }).catch(function () {});
  }

  window.rxCommerceTracking = {
    version: VERSION,
    snapshot: function () { return lastCart ? cartPayload(lastCart) : null; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
